import * as React from 'react'
import { Container } from 'components/Layout'
import cn from 'classnames'
import * as sText from 'components/Text/Text.scss'
import * as sMarg from 'styles/modules/margins.scss'
import { IShowAnalyticsShareModalProps } from './AnalyticsShareModal.action'
import { dispatchToProps } from './AnalyticsShareModal.container'
import LoadingOverlay from 'components/Loading/LoadingOverlay'
import TextBox from 'components/Text/TextBox'

export interface IAnalyticsShareModalProps extends IShowAnalyticsShareModalProps {
  modalCancel: () => undefined
  generateShareToken: typeof dispatchToProps['generateShareToken']
  shareToken: string
  loading: boolean
}

export class AnalyticsShareModal extends React.Component<IAnalyticsShareModalProps> {
  componentWillMount() {
    const { serviceId, generateShareToken } = this.props
    generateShareToken({
      method: 'GET',
      path: `/api/v1/numbers/${serviceId}/call-usage`,
    })
  }
  render() {
    const { shareToken, loading, serviceId } = this.props
    return (
      <Container paddingTop paddingBottom className="sm">
        {loading && <LoadingOverlay />}
        <div style={{ margin: '0 30px' }}>
          <div className={cn(sText.descrip2, sText.center, sMarg.mb30)}>Public Share Link</div>
          <div className={cn(sText.descrip3, sMarg.mb30, sText.center)}>
            This link will give public access to this service's call analytics. It will not expire
            so be careful who you send it to.
          </div>
          <TextBox>
            https://thinkpickle.com.au/wholesale-portal/analytics?serviceIds={serviceId}&token=
            {shareToken}
          </TextBox>
          <div className={cn(sText.descrip4, sMarg.mt30, sText.center)}>
            Optionally, you can link this to your own domain. For example:
            <br />
            <b>call-analytics.yourwebsite.com/wholesale-portal/analytics</b>
          </div>
          <div className={cn(sText.descrip5, sMarg.mt30, sText.center)}>
            Login to your DNS provider (you may need your developer to do this) and create a CNAME
            record with name: <b>call-analytics</b> and value:{' '}
            <b>call-analytics.thinkpickle.com.au</b>. In the link above, replace{' '}
            <b>https://thinkpickle.com.au</b> with <b>http://call-analytics.yourwebsite.com</b>
          </div>
        </div>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// src/features/CallAnalytics/AnalyticsShareModal/AnalyticsShareModal.tsx